<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import HolidaysRequest from './HolidaysRequest';
import HolidayTypeColumnVue from './components/HolidayTypeColumn.vue';
import HolidayStatusColumnVue from './components/HolidayStatusColumn.vue';

export default {
  name: 'HolidaysCrudList',
  extends: CrudListVue,
  data: () => ({
    requestClass: HolidaysRequest,
    editRoute: 'holidays.edit',
    headers: [
      {
        text: 'Data',
        value: 'date',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Tipo',
        value: 'type',
        component: HolidayTypeColumnVue,
      },
      {
        text: 'Status',
        value: 'isActive',
        component: HolidayStatusColumnVue,
      },
      {
        text: 'Criado por',
        value: 'createdByName',
      },
      {
        text: 'Última atualização',
        value: 'updatedAt',
        component: DataTableDateColumnVue,
      },
    ],
  }),
};
</script>
